// extracted by mini-css-extract-plugin
export var button = "multi-input-module--button--944f7";
export var dropdown = "multi-input-module--dropdown--e99bb";
export var dropdownItem = "multi-input-module--dropdown-item--e4695";
export var dropdownList = "multi-input-module--dropdown-list--36913";
export var error = "multi-input-module--error--5b665";
export var inputContainer = "multi-input-module--input-container--b9474";
export var label = "multi-input-module--label--3223d";
export var list = "multi-input-module--list--ab916";
export var listElement = "multi-input-module--list-element--76654";
export var listValue = "multi-input-module--list-value--7088f";